import { Skeleton } from '@/components/ui/Skeleton.tsx';
import { Card, CardContent, CardHeader } from '@/components/ui/Card.tsx';

const TourTransportConfigPageSkeleton = () => {
  return (
    <div className="space-y-4">
      {/* Breadcrumbs */}
      <div className="flex items-center gap-2 border-b border-neutral-100 pb-3">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="flex items-center gap-2">
            {i > 0 && <Skeleton className="h-3 w-3" />}
            <div className="flex items-center gap-1">
              <Skeleton className="h-4 w-4 rounded-lg" />
              <Skeleton className="h-4 w-16" />
            </div>
          </div>
        ))}
      </div>

      {/* Header: title + buttons */}
      <div className="flex items-center justify-between pt-4">
        <Skeleton className="h-10 w-64" />
        <div className="flex gap-2">
          <Skeleton className="h-10 w-20" />
          <Skeleton className="h-10 w-20" />
        </div>
      </div>

      {/* Main card */}
      <div className="mx-auto max-w-[600px] space-y-2">
        <Card>
          <CardHeader className="border-b">
            <Skeleton className="h-5 w-40" />
          </CardHeader>
          <CardContent className="space-y-4">
            <Skeleton className="h-10 w-72" />
            <Skeleton className="h-10 w-72" />
            <Skeleton className="h-40 w-full rounded-md" />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TourTransportConfigPageSkeleton;
